import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // Replace with actual auth logic

  useEffect(() => {
    // Simulate user login/session check
    const loggedInUser = {
      id: '123',
      employee_id: 'EMP001',
      email: 'test@example.com',
      name: 'Test User',
      username: 'testuser',
      role: 'admin',
      role_details: { name: 'Administrator' },
    };
    setUser(loggedInUser);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
